import { Dayjs } from "dayjs"

/**
 * Mirrors the `warrants_files_account_status` Postgres enum exposed by
 * Hasura on the be-financials source (confirmed via `enum_range` against
 * staging).
 */
export enum WarrantsFilesAccountStatus {
  PENDING = "pending",
  SUCCESS = "success",
  FAILED = "failed",
}

/**
 * Mirrors the `warrants_files_dca_type` Postgres enum (confirmed via
 * `enum_range` against staging).
 */
export enum WarrantsFilesDcaType {
  ENGAGE = "engage",
}

/**
 * Mirrors the `warrants_files_type` Postgres enum (confirmed via
 * `enum_range` against staging).
 */
export enum WarrantsFilesType {
  RETURNS = "returns",
  CANCELLATION = "cancellation",
}

export interface IWarrantsFilesAccount {
  id: number
  accountNumber: string
  customerName: string | null
  dcaType: WarrantsFilesDcaType
  fileType: WarrantsFilesType
  createdAt: Dayjs
  deletedAt: Dayjs | null
  jobId: number
  status: WarrantsFilesAccountStatus
  errorMessage: string | null
  retryCount: number

  /** `deleted_at` is set. */
  readonly isDeleted: boolean
  /** The status enum value rendered for display, e.g. 'Success'. */
  readonly statusDisplay: string
  /** The dca_type enum value rendered for display. */
  readonly dcaTypeDisplay: string
  /** The file_type enum value rendered for display. */
  readonly fileTypeDisplay: string
}
